import { Component, OnInit } from '@angular/core';
import {Partecipant} from "src/app/classes/common/partecipant";
import {PopoverController} from "@ionic/angular";
import {PopoverSelectComponent} from "../../../components/common/popover-select/popover-select.component";

@Component({
  selector: 'app-select-waypoint',
  templateUrl: './select-waypoint.component.html',
  styleUrls: ['./select-waypoint.component.scss'],
})
export class SelectWaypointComponent implements OnInit {

  type: string = 'address';
  selCar: Partecipant;

  constructor(
    private popoverCtrl: PopoverController,


  ) { }

  ngOnInit() {}

  ionViewDidEnter(){

  }

  selectWaypoint(event: any){
    console.log(event)
    // this.selectedWaypoint.emit();
  }


  // Apre le opzioni di ordinamento lista di sx
  async popoverType(event: any) {
    const popover =
      await this.popoverCtrl.create({
        backdropDismiss: true,
        component: PopoverSelectComponent,
        componentProps: {
          opts: [
            {
              id: "address",
              lbl: 'Indirizzo',
            },
            {
              id: "poi",
              lbl: 'Poi',
            },
            {
              id: "participant",
              lbl: 'Veicoli',
            },

          ],
        },
        cssClass: "popover_listPlain",
        event: event,
        showBackdrop: false,
      });

    await popover.present();

    const {data} = await popover.onWillDismiss();
    if (data && data.id){
      console.log(data)
    }
  }



}
